<!-- Comentario: avatar a la izquierda, nombre/fecha y contenido apilados a la derecha. Lógica intacta. -->
<div class="relative" [ngClass]="{'own-comment-border': me?.id === comment?.account?.id}">
    <div class="flex items-start gap-2">
        <img class="w-8 h-8 rounded-full object-cover flex-shrink-0" [src]="comment.account.picture+'?size=48'" *ngIf="comment?.account?.picture">
        <div class="w-8 h-8 rounded-full bg-[#E8EAEF] text-gray-500 flex items-center justify-center text-xs font-semibold flex-shrink-0" *ngIf="comment?.account && !comment?.account?.picture">
            {{ comment?.account?.name?.charAt(0) }}
        </div>

        <div class="flex flex-col min-w-0">
            <div class="flex items-center gap-2">
                <span class="text-sm font-normal text-gray-700" *ngIf="comment?.account">{{ comment.account.name }}</span>
                <span class="text-xs text-gray-400 font-normal">{{ getDate(comment.createdAt) }}</span>
            </div>

            <!-- Contenido del comentario -->
            <div class="mt-1 text-sm text-gray-500 leading-relaxed">
                <timeline-show-content [content]="comment.content"></timeline-show-content>
                <msc-link-manager [content]="comment.content.message" [class]="'m-link--blue'"></msc-link-manager>
            </div>
        </div>
    </div>

    <timeline-delete-content *ngIf="checkCanDelete()" [message]="'words.delete-confirm-comment'" (deleteContent)="onDeleteComment()"></timeline-delete-content>
</div>

<style>
    /* Borde del comentario propio del usuario (secondary), sin tocar nada más */
    .own-comment-border {
        border: 0.5px solid var(--secondary-color) !important;
        border-left: 4px solid var(--secondary-color) !important;
        border-radius: 12px !important;
    }
</style>
